import { ConfirmSetForm } from '../confirm-set-form/confirm-set-form';

export const DelSetForm = (props) => {
  const { close, action, working } = props;

  const title = 'Удалить выбранные записи?';

  const params = {
    title,
    close,
    action,
    working,
  };

  return <ConfirmSetForm {...params} />;
};
